/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketlinkkindlabel3Inputs */

const en_ticketlinkkindlabel3 = /** @type {(inputs: Ticketlinkkindlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does the link open?`)
};

const de_ticketlinkkindlabel3 = /** @type {(inputs: Ticketlinkkindlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was öffnet der Link?`)
};

/**
* | output |
* | --- |
* | "What does the link open?" |
*
* @param {Ticketlinkkindlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketlinkkindlabel3 = /** @type {((inputs?: Ticketlinkkindlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketlinkkindlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketlinkkindlabel3(inputs)
	return de_ticketlinkkindlabel3(inputs)
});
export { ticketlinkkindlabel3 as "ticketLinkKindLabel" }